"use strict";
function waitForElmCollection(selector) {
    // @ts-ignore
    return new Promise(function (resolve) {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }
        var observer = new MutationObserver(function (mutations) {
            if (document.querySelector(selector)) {
                resolve(document.querySelector(selector));
                observer.disconnect();
            }
        });
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
}
document.querySelectorAll('.filter-buttons button').forEach(function (button) {
    button.addEventListener('click', function () {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        (_a = document.querySelector(".collection-filter-popout")) === null || _a === void 0 ? void 0 : _a.classList.toggle('open');
        if (button.classList.contains('sort')) {
            (_b = document.querySelector('.filter-sort')) === null || _b === void 0 ? void 0 : _b.classList.toggle('d-none');
            (_c = document.querySelector('.filter-all')) === null || _c === void 0 ? void 0 : _c.classList.add('d-none');
            document.querySelector(".collection-filter-popout .filter-header p").textContent = "Sort";
        }
        else {
            (_d = document.querySelector('.filter-all')) === null || _d === void 0 ? void 0 : _d.classList.toggle('d-none');
            (_e = document.querySelector('.filter-sort')) === null || _e === void 0 ? void 0 : _e.classList.add('d-none');
            (_f = document.querySelector(".filter-footer")) === null || _f === void 0 ? void 0 : _f.classList.remove('d-none');
            document.querySelector(".collection-filter-popout .filter-header p").textContent = "Filter";
        }
        if (!((_g = document.querySelector('.filter-sort')) === null || _g === void 0 ? void 0 : _g.classList.contains('d-none')) || !((_h = document.querySelector('.filter-all')) === null || _h === void 0 ? void 0 : _h.classList.contains('d-none'))) {
            hideChatAndAwards(false);
        }
        else {
            hideChatAndAwards(true);
        }
    });
});
var sortBy = document.querySelector("select[name='sort_by']");
sortBy === null || sortBy === void 0 ? void 0 : sortBy.addEventListener('change', function (e) {
    var url = new URL(location.href);
    url.searchParams.append("sort_by", sortBy.value);
    location.assign(url.toString());
});
function handleCollapseSection(element) {
    var _a, _b, _c, _d;
    var filterItems = (_b = (_a = element.parentElement) === null || _a === void 0 ? void 0 : _a.parentElement) === null || _b === void 0 ? void 0 : _b.querySelector('.filter-items');
    filterItems === null || filterItems === void 0 ? void 0 : filterItems.classList.toggle('active-filter');
    filterItems === null || filterItems === void 0 ? void 0 : filterItems.classList.remove('desktop-active-filter');
    (_d = (_c = element.parentElement) === null || _c === void 0 ? void 0 : _c.querySelector('span')) === null || _d === void 0 ? void 0 : _d.classList.toggle('closed');
}
function handleCollapseSectionArrow(element) {
    var _a, _b, _c;
    var filterItems = (_c = (_b = (_a = element.parentElement) === null || _a === void 0 ? void 0 : _a.parentElement) === null || _b === void 0 ? void 0 : _b.parentElement) === null || _c === void 0 ? void 0 : _c.querySelector('.filter-items');
    filterItems === null || filterItems === void 0 ? void 0 : filterItems.classList.toggle('active-filter');
    filterItems === null || filterItems === void 0 ? void 0 : filterItems.classList.remove('desktop-active-filter');
    element.classList.toggle('closed');
}
function handleClearFilter(element) {
    var filterParam = element.getAttribute('data-filter-param') || '';
    var url = new URL(location.href);
    url.searchParams.delete(filterParam);
    location.assign(url.toString());
}
function hideChatAndAwards(show) {
    if (window.innerWidth < 992) {
        waitForElmCollection('#smile-ui-lite-container').then(function () {
            var smileContainer = document.getElementById('smile-ui-lite-container');
            if (smileContainer) {
                smileContainer.style.display = (show) ? "block" : "none";
            }
        });
        waitForElmCollection('#shopify-chat').then(function () {
            var chatContainer = document.getElementById('shopify-chat');
            if (chatContainer) {
                chatContainer.style.display = (show) ? "block" : "none";
            }
        });
    }
}
var specialsFilter = document.querySelector('.specials-filter');
if (specialsFilter) {
    var scrollIndicator_1 = specialsFilter.querySelector('.swipe-indicator');
    if (scrollIndicator_1) {
        scrollIndicator_1.classList.remove("hidden-xl-up");
        var hasHorizontalScroll = specialsFilter.scrollWidth > specialsFilter.clientWidth;
        if (!hasHorizontalScroll) {
            scrollIndicator_1.classList.add("d-none");
        }
        specialsFilter.addEventListener('scroll', function () {
            scrollIndicator_1.classList.add("d-none");
        });
    }
    scrollIndicator_1 === null || scrollIndicator_1 === void 0 ? void 0 : scrollIndicator_1.addEventListener("click", function () {
        var _a;
        (_a = scrollIndicator_1.parentElement) === null || _a === void 0 ? void 0 : _a.scrollTo({
            left: 200,
            behavior: 'smooth'
        });
    });
}
function handleClosePopout() {
    var _a, _b, _c, _d;
    (_a = document.querySelector(".collection-filter-popout")) === null || _a === void 0 ? void 0 : _a.classList.remove('open');
    (_b = document.querySelector(".filter-footer")) === null || _b === void 0 ? void 0 : _b.classList.add('d-none');
    (_c = document.querySelector('.filter-sort')) === null || _c === void 0 ? void 0 : _c.classList.add('d-none');
    (_d = document.querySelector('.filter-all')) === null || _d === void 0 ? void 0 : _d.classList.add('d-none');
}
function handleLabelClick(e) {
    e.preventDefault();
    e.target.parentElement.querySelector('input').click();
}
// TODO: only run on bundles page
// document.addEventListener('bundler:loaded', function(e) {
//   const config: {
//     [key: string]: {
//       url: string;
//       image: string;
//     }
//   } = {
//     "670324": {
//       url: "https://coffeecapsulesdirect.co.za/a/bundles/coffee-capsules-direct-signature-range-ed84",
//       image: "https://coffeecapsulesdirect.co.za/cdn/shop/files/CCD_BundleProducts_Bulk-Special-Pack-No-Decaffe.jpg?v=1723094328",
//     },
//     "670364": {
//       url: "https://coffeecapsulesdirect.co.za/a/bundles/the-ultimate-coffee-machine-cleaning-bundle-ed98",
//       image: "https://coffeecapsulesdirect.co.za/cdn/shop/products/Amazon_Caffenu_Nespresso_CleaningCapsules_MainProduct_255x255.jpg?v=1642430740",
//     }
//   }
//   // @ts-ignore
//   const bundles = window.bndlr.getBundles();
//   const page: number = 1;
//   const products = document.querySelectorAll('.collection-grid .products .product');
//   const container = document.querySelector('.collection-grid .products-container');
//   console.log({
//     bundles,
//     page,
//   })
//   for (let i = 0; i < bundles.length; i++) {
//     if (i > 0) break;
//     const bundleItem = bundles[i];
//     const index = (i + 1) * 3;
//     const element = products[index].parentElement;
//     const url: string = config[bundleItem.id.toString()]?.url || '#';
//     const image: string = config[bundleItem.id.toString()]?.image || '#';
//     const bundleElement = `
//       <div class="product bundle-product d-flex w-100" data-price="19900" data-compare-price="29900">
//         <div class="d-flex flex-row justify-content-between w-100">
//           <div class="flex-2">
//             <a href="${url}">
//               <div class="badges">
//                 <div class="badge teal savings-badge"><span>10%</span> off</div>
//               </div>
//               <div class="images-wrapper">
//                 <img src="${image}" alt="">
//               </div>
//             </a>
//           </div>
//           <div class="d-flex justify-content-center flex-column flex-1 p-l-15">
//             <h3 class="header-5 d-flex align-items-center" style="color: #ceac52"><img src="https://cdn.shopify.com/s/files/1/0505/3071/3798/files/CCD_Website_SingleProductIcons_Nespresso.svg?v=1748523243" alt="">Bundle & Save</h3>
//             <h2 class="header-4">${bundleItem.name}</h2>
//             <p class="price">From R59.99</p>
//             <div><div class="savings-amount">Save <span>10%</span></div></div>
//             <div class="button-wrapper">
//               <a href="${url}" data-id="" class="add-to-cart product-item-add-to-cart d-flex align-items-center justify-content-center w-100">
//                 <span>View</span>
//               </a>
//             </div>
//           </div>
//         </div>
//       </div>
//     `;
//     const bundleElementContainer = document.createElement('div');
//     bundleElementContainer.className = 'col-12 d-flex mb-30';
//     bundleElementContainer.innerHTML = bundleElement;
//     container?.insertBefore(bundleElementContainer, element);
//   }
//   // TODO: handle collections with 1 or 2 products
// });
var loadMoreSpinner = document.getElementById('LoadMoreSpinner');
var productContainer = document.querySelector(".products-container");
var loadingMore = false;
if (loadMoreSpinner) {
    var loadMoreObserver = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting) {
                loadNextPage();
            }
        });
    });
    loadMoreObserver.observe(loadMoreSpinner);
}
function loadNextPage() {
    if (loadingMore)
        return;
    loadingMore = true;
    loadMoreSpinner === null || loadMoreSpinner === void 0 ? void 0 : loadMoreSpinner.classList.toggle("opacity-0");
    var nextUrl = (loadMoreSpinner === null || loadMoreSpinner === void 0 ? void 0 : loadMoreSpinner.getAttribute("data-next-url")) || "";
    if (!nextUrl || !productContainer)
        return;
    fetch(nextUrl)
        .then(function (res) { return res.text(); })
        .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, "text/html");
        var newProducts = doc.querySelectorAll('.products-container > *');
        if (!newProducts)
            return;
        newProducts.forEach(function (product) { return productContainer.appendChild(product); });
        var pItems = document.querySelectorAll('.product');
        if (!pItems)
            return;
        setupProductItems(pItems);
        setupAddToCartListeners();
        var newNextBtn = doc.querySelector('#LoadMoreSpinner');
        if (!newNextBtn) {
            loadMoreSpinner === null || loadMoreSpinner === void 0 ? void 0 : loadMoreSpinner.remove();
            return;
        }
        var newUrl = newNextBtn.getAttribute("data-next-url") || "";
        loadMoreSpinner === null || loadMoreSpinner === void 0 ? void 0 : loadMoreSpinner.setAttribute("data-next-url", newUrl);
        loadMoreSpinner === null || loadMoreSpinner === void 0 ? void 0 : loadMoreSpinner.classList.toggle("opacity-0");
        loadingMore = false;
    });
}
